import React, { useState, useContext, useEffect } from "react";
import { Field } from "formik";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import {
  FieldButtonGroup,
  FieldDropSide,
  SearchableList,
  FieldInput,
  FieldTextarea,
  FieldInputNumber,
  DatePicker,
  MultiSelectDropdown,
  AddButton,
  Link,
  CsplTable as Table,
  FieldMultiSelectButtonGroup,
  AddPlans,
  SliderPanel,
  LoaderWrapper,
} from "../../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  yesNoOptions,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  usDateFormat,
  toMultiSelectValueById,
  getPathWithParam,
  FLOW_TYPES,
  MANAGE_PLAN_ROUTES,
  getNullTableItem,
  competingFundsList,
} from "../../../../utils";
import { createPlanStore } from "../../../../contexts";
import { useRequest } from "../../../../abstracts";
import {
  getApplicableInvestments,
  getCompetingFunds,
  getInvestmentType,
  listAdvisor,
} from "../../../../services";
import { isEmpty, get } from "lodash";
import ModelPortfolio from "../../../Rkaas/Investment/AddInvestmentContainer/BasicDetails/ModelPortfolio";
import AddRestrictions from "./AddRestrictions";

const restrictionLabel = {
  1: "No of days with restriction",
  2: "No of weeks with restriction",
  3: "No of months with restriction",
  4: "No of years with restriction",
};

const columns = [
  {
    label: "Effective Start Date",
    className: "column-inv-effective-start-date",
    columnName: "effectiveStartDate",
  },
  {
    label: "Effective End Date",
    className: "column-inv-effective-end-date",
    columnName: "effectiveEndDate",
    type: "date",
  },
  {
    label: "Applicable Types",
    className: "column-inv-applicable-types",
    columnName: "applicableTypes",
    dataMapper: OPTIONS_DATA_MAPPER.TEMP_APPLICABLE_TYPES,
  },
  {
    label: "Action",
    className: "column-action",
    columnName: "action",
  },
];

const BasicDetails = (props) => {
  const { state } = useContext(createPlanStore);

  const {
    fields,
    values,
    setFieldValue,
    isEdit,
    isSave,
    handleChange,
    investmentId,
    restrictions,
    setRestrictions,
    isInnerFormDirty,
    setIsInnerFormDirty,
    setTabGrey,
    planId,
    restrictionsList,
    masterInvestmentData,
  } = props;
  const { response: advisorlist } = useRequest({
    method: listAdvisor,
    payload: planId,
    defaultResponse: [],
  });
  const advisorsData = get(advisorlist, "advisors", []);
  const { response: competingFundsList } = useRequest({
    method: getCompetingFunds,
    payload: investmentId != undefined ? investmentId : 0,
    defaultResponse: [],
  });
  const masterInvestmentStatus = get(masterInvestmentData, "status");
  const typeOfEarnings = get(values, fields.typeOfEarnings, []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [data, setData] = useState({});
  const [dataChangeIndex, setDataChangeIndex] = useState("");
  const [investmentsList, setInvestmentsList] = useState([]);
  const [investmentTypes, setInvestmentTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    getApplicableInvestments()
      .then((response) => {
        setInvestmentsList(response);
      })
      .catch((ex) => {
        setLoading(false);
      });
    getInvestmentType()
      .then((response) => {
        setLoading(false);
        setInvestmentTypes(response);
      })
      .catch((ex) => {
        setLoading(false);
      });
  }, []);

  const addRestrictionClick = () => {
    setIsModalOpen(!isModalOpen);
  };

  const deleteRestriction = (idx) => {
    setRestrictions(restrictions.filter((_, i) => i != idx));
  };

  const resetTierDetails = () => {
    setFieldValue(fields.restrictions, []);
  };

  const getInvestmentStatusApplicableListArray =
    masterInvestmentStatus === 1
      ? [1, 2, 3, 4]
      : masterInvestmentStatus === 2
      ? [2]
      : masterInvestmentStatus === 3
      ? [2, 3, 4]
      : masterInvestmentStatus === 4
      ? [2, 4]
      : [];

  const getInvestmentStatusApplicableList = getInvestmentStatusApplicableListArray.map(
    (_) => {
      return { [_]: OPTIONS_DATA_MAPPER.INVESTMENT_STATUS_MASTER[_] };
    }
  );

  return (
    <LoaderWrapper isLoading={loading}>
      <>
        <Field
          size="md"
          isRequired
          name={fields.type}
          label={"Investment Type"}
          value={values[fields.type]}
          disabled={true}
          options={
            investmentTypes &&
            investmentTypes.map((type, index) => ({
              label: type.name,
              value: parseInt(type.id),
            }))
          }
          popupContent={
            <SearchableList
              label="Select an Investment Type"
              // isNotTypeAhead
              isRadio
              selectedValue={values[fields.type]}
              options={
                investmentTypes &&
                investmentTypes.map((type, index) => ({
                  label: type.name,
                  value: parseInt(type.id),
                }))
              }
              onSelect={(value) => {
                setTabGrey(1);
                setFieldValue(fields.type, value);
              }}
            />
          }
          component={FieldDropSide}
        />
        {values[fields.type] === 1 ? (
          <ModelPortfolio
            fields={fields}
            isEdit={isEdit}
            isSave={isSave}
            setTabGrey={setTabGrey}
            investmentsList={investmentsList}
            intInvestmentId={investmentId}
            isPlan={true}
            investmentStatusOptions={toOptionValuesFromMapper(
              Object.assign({}, ...getInvestmentStatusApplicableList)
            )}
          />
        ) : (
          <>
            <Field
              name={fields.investmentCategory}
              isRequired
              label="Investment Cateogry"
              value={values[fields.investmentCategory]}
              disabled={true}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.INVESTMENT_CATEGORY
              )}
              popupContent={
                <div>
                  <SearchableList
                    label="Select an investment category"
                    options={toOptionValuesFromMapper(
                      OPTIONS_DATA_MAPPER.INVESTMENT_CATEGORY
                    )}
                    onSelect={(value) => {
                      setTabGrey(1);
                      setFieldValue(fields.investmentCategory, value);
                    }}
                    disabled={true}
                  />
                  {/* Create a new Investment category */}
                </div>
              }
              component={FieldDropSide}
            />
            <Field
              size="smd"
              name={fields.accountType}
              label={"Account Type"}
              isRequired
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.ACCOUNT_TYPE_MASTER
              )}
              selectedValue={values[fields.accountType]}
              value={values[fields.accountType]}
              onChange={(value) => {
                setTabGrey(1);
                setFieldValue(fields.accountType, value);
              }}
              component={FieldButtonGroup}
              disabled={true}
            />
            <Field
              name={fields.name}
              label={"Investment Name"}
              isRequired
              selectedValue={values[fields.name]}
              value={values[fields.name]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              component={FieldInput}
              disabled={true}
            />
            <Field
              name={fields.alias}
              // isRequired
              label={"Alias"}
              size="smd"
              selectedValue={values[fields.alias]}
              value={values[fields.alias]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              component={FieldInput}
              disabled={isEdit && !isSave}
            />
            <Field
              isRequired
              name={fields.advisors}
              label={"Advisor Rep."}
              isMultiSelect
              value={toMultiSelectValueById(
                values[fields.advisors],
                advisorsData &&
                  advisorsData.map((item, index) => ({
                    label: item.advisorCompanyName,
                    value: item.advisorPlanMapId,
                  }))
              )}
              popupContent={
                <MultiSelectDropdown
                  label="Advisor Rep."
                  name={fields.advisors}
                  onSelect={(value) => {
                    setTabGrey(1);
                    setFieldValue(fields.advisors, value);
                  }}
                  value={values[fields.advisors]}
                  options={
                    advisorsData &&
                    advisorsData.map((item, index) => ({
                      label: item.advisorCompanyName,
                      value: item.advisorPlanMapId,
                    }))
                  }
                  disabled={isEdit && !isSave}
                  isTypeAhead
                />
              }
              disabled={isEdit && !isSave}
              component={FieldDropSide}
            />

            <Field
              name={fields.description}
              label={"Investment Description"}
              // isRequired
              // placeholder="Placeholder"
              selectedValue={values[fields.description]}
              value={values[fields.description]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              component={FieldTextarea}
              disabled={true}
            />
            <Field
              name={fields.status}
              isRequired
              label="Investment Status"
              value={values[fields.status]}
              disabled={isEdit && !isSave}
              options={toOptionValuesFromMapper(
                Object.assign({}, ...getInvestmentStatusApplicableList)
              )}
              popupContent={
                <SearchableList
                  label="Select an investment status"
                  options={toOptionValuesFromMapper(
                    Object.assign({}, ...getInvestmentStatusApplicableList)
                  )}
                  onSelect={(value) => setFieldValue(fields.status, value)}
                  onChange={() => {
                    setTabGrey(1);
                    setFieldValue(fields.suspendedFromDate, null);
                    setFieldValue(fields.suspendedToDate, null);
                    setFieldValue(fields.inceptionDate, null);
                  }}
                  disabled={isEdit && !isSave}
                  isNotTypeAhead
                />
              }
              component={FieldDropSide}
            />
            {values[fields.status] === 4 && (
              <>
                <Field
                  size="smd"
                  name={fields.suspendedFromDate}
                  placeholder="To"
                  value={usDateFormat(values[fields.suspendedFromDate])}
                  direction="right"
                  isDatePicker
                  isRequired
                  label="Suspended From"
                  onClear={() => setFieldValue(fields.suspendedFromDate, "")}
                  popupContent={
                    <DatePicker
                      onDayClick={(value) => {
                        setTabGrey(1);
                        setFieldValue(fields.suspendedFromDate, value);
                      }}
                      value={usDateFormat(values[fields.suspendedFromDate])}
                    />
                  }
                  disabled={isEdit && !isSave}
                  component={FieldDropSide}
                />
                <Field
                  size="smd"
                  name={fields.suspendedToDate}
                  placeholder="To"
                  value={usDateFormat(values[fields.suspendedToDate])}
                  direction="right"
                  isDatePicker
                  onClear={() => setFieldValue(fields.suspendedToDate, "")}
                  label="Suspended to"
                  isRequired
                  popupContent={
                    <DatePicker
                      onDayClick={(value) => {
                        setTabGrey(1);
                        setFieldValue(fields.suspendedToDate, value);
                      }}
                      value={usDateFormat(values[fields.suspendedToDate])}
                    />
                  }
                  disabled={isEdit && !isSave}
                  component={FieldDropSide}
                />
              </>
            )}
            <Field
              size="smd"
              isRequired
              name={fields.inceptionDate}
              label={"Investment Inception Date"}
              value={usDateFormat(values[fields.inceptionDate])}
              isDatePicker
              onClear={() => setFieldValue(fields.inceptionDate, "")}
              popupContent={
                <DatePicker
                  maxDate={new Date()}
                  onDayClick={(value) => {
                    setTabGrey(1);
                    setFieldValue(fields.inceptionDate, value);
                  }}
                  value={usDateFormat(values[fields.inceptionDate])}
                />
              }
              disabled={true}
              component={FieldDropSide}
            />
            <Field
              size="md"
              isRequired
              name={fields.fundCode}
              label={"Fund Code"}
              type="text"
              autoComplete="off"
              value={values[fields.fundCode]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              disabled={true}
              component={FieldInput}
            />

            <Field
              size="md"
              name={fields.fundFamily}
              label={"Fund Family"}
              type="text"
              autoComplete="off"
              maxLength="4"
              preventSpecialCharacter={true}
              value={values[fields.fundFamily]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              disabled={true}
              component={FieldInput}
            />

            <Field
              size="md"
              isRequired
              name={fields.cusip}
              label="CUSIP"
              noLabelTransform={true}
              type="text"
              autoComplete="off"
              value={values[fields.cusip]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              disabled={true}
              component={FieldInput}
            />
            <Field
              size="md"
              isRequired
              name={fields.sedol}
              label="SEDOL"
              noLabelTransform={true}
              type="text"
              autoComplete="off"
              maxLength="7"
              preventSpecialCharacter={true}
              value={values[fields.sedol]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              disabled={true}
              component={FieldInput}
            />
            <Field
              size="md"
              isRequired
              name={fields.isin}
              label="ISIN"
              noLabelTransform={true}
              type="text"
              autoComplete="off"
              maxLength="12"
              preventSpecialCharacter={true}
              value={values[fields.isin]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              disabled={true}
              component={FieldInput}
            />
            <Field
              size="smd"
              name={fields.ticker}
              label={"Ticker"}
              type="text"
              autoComplete="off"
              value={values[fields.ticker]}
              onChange={(e) => {
                setTabGrey(1);
                handleChange(e);
              }}
              disabled={true}
              component={FieldInput}
            />
            <Field
              size="smd"
              isRequired
              name={fields.shareClass}
              label={"Share Class"}
              value={values[fields.shareClass]}
              disabled={true}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.INVESTMENT_SHARE_CLASS
              )}
              popupContent={
                <SearchableList
                  label="Select a Share Class"
                  isNotTypeAhead
                  isRadio
                  selectedValue={values[fields.shareClass]}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.INVESTMENT_SHARE_CLASS
                  )}
                  onSelect={(value) => {
                    setTabGrey(1);
                    setFieldValue(fields.shareClass, value);
                  }}
                />
              }
              component={FieldDropSide}
            />
            <Field
              size="lg"
              isRequired
              name={fields.typeOfEarnings}
              label={"Type Of Earnings"}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.TYPE_OF_EARNINGS
              )}
              selectedValue={typeOfEarnings}
              value={typeOfEarnings}
              onChange={(value) => {
                setTabGrey(1);
                setFieldValue(fields.typeOfEarnings, value);
              }}
              component={FieldMultiSelectButtonGroup}
              disabled={true}
            />

            <Field
              size="sm"
              isRequired
              name={fields.isInvestmentQDIA}
              label={"Is this a QDIA Investment?"}
              noLabelTransform
              options={yesNoOptions}
              selectedValue={values[fields.isInvestmentQDIA]}
              value={values[fields.isInvestmentQDIA]}
              onChange={(value) => {
                setTabGrey(1);
                setFieldValue(fields.isInvestmentQDIA, value);
              }}
              component={FieldButtonGroup}
              disabled={true}
            />
            <Field
              isRequired
              name={fields.volatility}
              label={"Volatility"}
              value={values[fields.volatility]}
              disabled={true}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.INVESTMENT_VOLATILITY
              )}
              popupContent={
                <SearchableList
                  label="Select a Volatility"
                  isNotTypeAhead
                  isRadio
                  selectedValue={values[fields.volatility]}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.INVESTMENT_VOLATILITY
                  )}
                  onSelect={(value) => {
                    setTabGrey(1);
                    setFieldValue(fields.volatility, value);
                  }}
                />
              }
              component={FieldDropSide}
            />
            <Field
              isRequired
              name={fields.prospectusDeliveryMethod}
              label={"Prospectus Delivery Method"}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.PROSPECTUS_DELIVERY_METHOD
              )}
              selectedValue={values[fields.prospectusDeliveryMethod]}
              value={values[fields.prospectusDeliveryMethod]}
              onChange={(value) => {
                setTabGrey(1);
                setFieldValue(fields.prospectusDeliveryMethod, value);
              }}
              component={FieldMultiSelectButtonGroup}
              disabled={true}
            />

            <Field
              size="sm"
              name={fields.isEquityWashRuleApplicable}
              label={"Equity Wash Rule"}
              isRequired
              options={yesNoOptions}
              selectedValue={values[fields.isEquityWashRuleApplicable]}
              value={values[fields.isEquityWashRuleApplicable]}
              onChange={(value) => {
                setTabGrey(1);
                setFieldValue(fields.isEquityWashRuleApplicable, value);
              }}
              component={FieldButtonGroup}
              disabled={true}
            />
            {values[fields.isEquityWashRuleApplicable] && (
              <>
                <Field
                  isRequired
                  name={fields.competingFunds}
                  label={"Competing Fund(s)"}
                  isMultiSelect
                  value={toMultiSelectValueById(
                    values[fields.competingFunds],
                    competingFundsList.map((item, index) => ({
                      label: item.investmentName,
                      value: parseInt(item.investmentId),
                    }))
                  )}
                  popupContent={
                    <MultiSelectDropdown
                      label="Competing Fund(s)"
                      name={fields.competingFunds}
                      onSelect={(value) => {
                        setTabGrey(1);
                        setFieldValue(fields.competingFunds, value);
                      }}
                      value={values[fields.competingFunds]}
                      options={competingFundsList.map((item, index) => ({
                        label: item.investmentName,
                        value: parseInt(item.investmentId),
                      }))}
                      disabled={true}
                      isTypeAhead
                    />
                  }
                  disabled={true}
                  component={FieldDropSide}
                />
                <Field
                  isRequired
                  name={fields.restrictedPeriod}
                  label={"Restricted Period"}
                  value={values[fields.restrictedPeriod]}
                  disabled={true}
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.RESTRICTED_PERIOD
                  )}
                  popupContent={
                    <SearchableList
                      label="Restricted Period"
                      isNotTypeAhead
                      isRadio
                      selectedValue={values[fields.restrictedPeriod]}
                      options={toOptionValuesFromMapper(
                        OPTIONS_DATA_MAPPER.RESTRICTED_PERIOD
                      )}
                      onChange={() => {
                        setTabGrey(1);
                        setFieldValue(fields.restrictedPeriodValue, null);
                      }}
                      onSelect={(value) =>
                        setFieldValue(fields.restrictedPeriod, value)
                      }
                    />
                  }
                  component={FieldDropSide}
                />
                <Field
                  size="smd"
                  isRequired
                  name={fields.restrictedPeriodValue}
                  label={
                    values[fields.restrictedPeriod] &&
                    restrictionLabel[values[fields.restrictedPeriod]]
                  }
                  type="number"
                  autoComplete="off"
                  value={values[fields.restrictedPeriodValue]}
                  onChange={(e) => {
                    setTabGrey(1);
                    handleChange(e);
                  }}
                  disabled={true}
                  component={FieldInputNumber}
                  max={
                    values[fields.restrictedPeriodTypeFrequency] === 1 ? 99 : 11
                  }
                />
              </>
            )}
            <Field
              name={fields.postingRulesForSells}
              isRequired
              label="Posting Rules For Sells"
              value={values[fields.postingRulesForSells]}
              disabled={true}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.POSTING_RULES
              )}
              popupContent={
                <SearchableList
                  label="Select an posting rules for sells"
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.POSTING_RULES
                  )}
                  onSelect={(value) =>
                    setFieldValue(fields.postingRulesForSells, value)
                  }
                  onChange={() => {
                    setTabGrey(1);
                  }}
                  disabled={isEdit && !isSave}
                  isNotTypeAhead
                />
              }
              component={FieldDropSide}
            />
            <Field
              name={fields.postingRulesForBuys}
              isRequired
              label="Posting Rules For Buys"
              value={values[fields.postingRulesForBuys]}
              disabled={true}
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.POSTING_RULES
              )}
              popupContent={
                <SearchableList
                  label="Select an posting rules for buys"
                  options={toOptionValuesFromMapper(
                    OPTIONS_DATA_MAPPER.POSTING_RULES
                  )}
                  onSelect={(value) =>
                    setFieldValue(fields.postingRulesForBuys, value)
                  }
                  onChange={() => {
                    setTabGrey(1);
                  }}
                  isNotTypeAhead
                />
              }
              component={FieldDropSide}
            />
            <div className="line-separator" />
            <div className="d-flex justify-content-between bg-title">
              <div>
                <h4 className="ft-20">Restriction(s)</h4>
              </div>
              <div>
                <AddButton
                  menu="plan"
                  subMenu="manageInvestmentsPlan"
                  onAddClick={addRestrictionClick}
                  disabled={isEdit && !isSave}
                />
              </div>
            </div>
            {isEmpty(restrictions) ? (
              <AddPlans
                menu="plan"
                subMenu="manageInvestmentsPlan"
                content="No Restrictions"
                buttonLabel="Add Restrictions"
                className="h-auto"
                disabled={isEdit && !isSave}
                onPrimaryClick={addRestrictionClick}
              />
            ) : (
              <div className="redemption-gate-table w-100">
                <Table>
                  <Table.Thead>
                    <Table.Tr>
                      {columns.map((item, index) => {
                        return (
                          <Table.Th key={index} className={item.className}>
                            {item.label}
                          </Table.Th>
                        );
                      })}
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {restrictions.map((restriction, index) => {
                      return (
                        <>
                          <Table.Tr key={index}>
                            {columns.map((item, cellIndex) => {
                              const getContent = () => {
                                if (item.columnName == "action") {
                                  return [
                                    <FontAwesomeIcon
                                      icon={faPencilAlt}
                                      size="lg"
                                      color="#3a3974"
                                      className={
                                        isEdit
                                          ? "cursor-not-allowed"
                                          : "pointer"
                                      }
                                      disabled={isEdit && !isSave}
                                      onClick={() => {
                                        if (!isEdit) {
                                          setEdit(true);
                                          setData(restriction);
                                          setDataChangeIndex(index);
                                          addRestrictionClick();
                                        }
                                      }}
                                    />,

                                    <span>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>,

                                    <FontAwesomeIcon
                                      icon={faTrashAlt}
                                      size="lg"
                                      color="#ff5050"
                                      className={
                                        isEdit
                                          ? "cursor-not-allowed"
                                          : "pointer"
                                      }
                                      disabled={isEdit && !isSave}
                                      onClick={() => {
                                        if (!isEdit) deleteRestriction(index);
                                      }}
                                    />,
                                  ];
                                }
                                if (
                                  item.columnName == "effectiveStartDate" ||
                                  item.columnName == "effectiveEndDate"
                                ) {
                                  return usDateFormat(
                                    restriction[item.columnName]
                                  );
                                }
                                if (item.columnName === "applicableTypes") {
                                  return (
                                    get(restriction, "applicableTypes") || []
                                  )
                                    .map((val) => {
                                      return item.dataMapper[val];
                                    })
                                    .join(", ");
                                }
                                return restriction[item.columnName];
                              };
                              return (
                                <Table.Td
                                  key={cellIndex}
                                  className={item.className}
                                >
                                  {getNullTableItem(getContent())}
                                </Table.Td>
                              );
                            })}
                          </Table.Tr>
                        </>
                      );
                    })}
                  </Table.Tbody>
                </Table>
                <br />
                <Link
                  to={getPathWithParam({
                    path: MANAGE_PLAN_ROUTES.VIEW_INV_RESTRICTION_HISTORY,
                    pathParam: [FLOW_TYPES.EDIT, planId, investmentId],
                  })}
                  disabled={isEdit && !isSave}
                  className="blue-link"
                >
                  Restriction History
                </Link>
              </div>
            )}
          </>
        )}
        <SliderPanel isOpen={isModalOpen} size="45" showCancel={false}>
          <AddRestrictions
            {...props}
            data={data}
            dataChangeIndex={dataChangeIndex}
            edit={edit}
            setEdit={setEdit}
            restrictions={restrictions}
            setRestrictions={setRestrictions}
            {...{ isInnerFormDirty, setIsInnerFormDirty }}
            addRestrictionClick={addRestrictionClick}
            setTabGrey={setTabGrey}
          />
        </SliderPanel>
      </>
    </LoaderWrapper>
  );
};
export default BasicDetails;
